export * from './quillEditor.module';



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/ng2-quill-editor/index.ts